const locale: Locale = {
  ko: {
    signin: '로그인',
    myinfo: '내 정보',
    mine: '나의 청원',
    account: '회원 정보 관리',
    signout: '로그아웃',
  },
  en: {
    signin: 'Sign In',
    myinfo: 'My Info',
    mine: 'My Petitions',
    account: 'Account',
    signout: 'Sign Out',
  },
}

export default locale
